import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseAppComponent, PagesModule } from '@r1-development/rps-shared-ui';
import { ClientSideRowModelModule, ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule } from 'ag-grid-enterprise';

// Register AG Grid modules
ModuleRegistry.registerModules([ClientSideRowModelModule, AllEnterpriseModule]);

@Component({
  selector: 'app-root',
  imports: [PagesModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent extends BaseAppComponent {
  constructor(
    protected override readonly activatedRoute: ActivatedRoute,
    protected override readonly router: Router,
    protected override readonly titleService: Title
  ) {
    super(activatedRoute, router, titleService);
  }
}
